import { CommonWrap } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box } from "@mui/material";
import { useLocales } from "@/locales";
import CodeSnippet from "@/components/CodeSnippet";
import ShowTable from "@/DocLayout/Table/index";
import { GET_COIN_USDT_PRICE_URL } from "@/config";
import { codeMap } from "@/PageCodeComponents/PublicResourceApi";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import { useContext } from "react";
import PostRequest from "@/components/PostRequest";

export default function GetCoinPrice() {
  const { translate } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  return (
    <>
      <ContentWrap
        id="get-token-price"
        showBorderBottom={false}
        leftChildrenSx={{
          paddingBottom: "1px",
        }}
        leftChildren={
          <CommonWrap>
            <Box component={"div"} className="title_0" mt={3}>
              {translate("public_resource.get_coin_price_title")}
            </Box>

            <Box component={"div"} className="desc" mb={3}>
              <PostRequest url={GET_COIN_USDT_PRICE_URL} />
            </Box>
          </CommonWrap>
        }
      />
      <ContentWrap
        showBorderBottom={false}
        leftChildrenSx={{
          paddingTop: "32px",
          paddingBottom: "1px",
        }}
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_params")}</Box>
            <ShowTable
              tableData={[
                {
                  name: "coinIds",
                  type: "Array",
                  is_: translate("common.params_is"),
                  desc: translate(
                    "public_resource.get_coin_price_req_table_desc1"
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <>
            <CodeSnippet
              title={translate("common.http_request_ex")}
              code={codeMap["coin_price"][language].http_ex_code}
            />
          </>
        }
      />

      {/* 返回参数 */}

      <ContentWrap
        leftChildrenSx={{
          paddingTop: "2px",
        }}
        leftChildren={
          <CommonWrap>
            <Box component={"div"} className="title_1" mt={3}>
              {translate("common.http_res")}
            </Box>

            <ShowTable
              res={true}
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: " ",
                },
                {
                  name: "data.prices",
                  type: "Object",
                  desc: " ",
                },
                {
                  name: "data.prices[coinId]",
                  type: "String",
                  desc: translate(
                    "public_resource.get_coin_price_res_table_desc1"
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <>
            <CodeSnippet
              title={translate("common.http_result")}
              code={codeMap["coin_price"].response}
            />
          </>
        }
      />
    </>
  );
}
